export const SET_SHOW_ARCHIVED_PLANS = 'SET_SHOW_ARCHIVED_PLANS';
export function setShowArchivedPlans(showArchivedPlans) {
  return { type: SET_SHOW_ARCHIVED_PLANS, showArchivedPlans };
}
